import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import Input from "components/DesignSystem/Input/Input";
import { useToast } from "hooks/useToast";
import { useUpdateFormTemplateTitleMutation } from "store/apis/incorporationFormBuilder";
import { BackendError } from "types/utils/error";
import * as yup from "yup";

type FormValues = {
  title: string;
};

const validationSchema = yup.object({
  title: yup.string().required("Template name is required"),
});

type EditTemplateNameModalProps = {
  isOpen: boolean;
  close: () => void;
  templateId: string;
  currentTitle: string;
};

export const EditTemplateNameModal = ({
  isOpen,
  close,
  templateId,
  currentTitle,
}: EditTemplateNameModalProps) => {
  const { alertToast } = useToast();
  const [updateTemplateTitle, { isLoading }] =
    useUpdateFormTemplateTitleMutation();

  const onSubmit = async (values: FormValues) => {
    try {
      await updateTemplateTitle({ templateId, title: values.title }).unwrap();
      close();
    } catch (err) {
      alertToast({
        message:
          (err as BackendError)?.data?.error?.message ?? "Something went wrong",
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content asChild>
        <FormikForm<FormValues>
          initialValues={{ title: currentTitle }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ values }) => (
            <>
              <Modal.Header>
                <Modal.Title>Edit Template Name</Modal.Title>
                <Modal.Close />
              </Modal.Header>

              <Modal.Body>
                <Input withForm name="title" label="Template name" required />
              </Modal.Body>

              <Modal.FooterButtonGroup>
                <Modal.RawClose asChild>
                  <Button type="button">Cancel</Button>
                </Modal.RawClose>
                <Button
                  customType="primary"
                  type="submit"
                  isLoading={isLoading}
                  disabled={isLoading || !values.title}
                >
                  Save
                </Button>
              </Modal.FooterButtonGroup>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
